import imgAnxiety from "@/assets/conditions/anxiety-and-depression.jpg";
import imgTravelersDiarrhea from "@/assets/conditions/travelers-diarrhea.jpg";
import imgDengue from "@/assets/conditions/dengue-and-tropical-fevers.jpg";
import imgRespiratory from "@/assets/conditions/respiratory-infections.jpg";
import imgSkin from "@/assets/conditions/skin-rashes-insect-bites.jpg";
import imgUti from "@/assets/conditions/urinary-tract-infections.jpg";
import imgRefills from "@/assets/conditions/prescription-refills.jpg";
import imgPediatrics from "@/assets/conditions/childrens-health-pediatrics.jpg";
import imgSunburn from "@/assets/conditions/sunburn-heat-illness.jpg";
import imgFoodPoisoning from "@/assets/conditions/food-poisoning-stomach-pain.jpg";
import imgSwimmersEar from "@/assets/conditions/swimmers-ear-and-ear-infections.jpg";
import imgMinorInjuries from "@/assets/conditions/minor-injuries-and-beach-accidents.jpg";
import imgSexualHealth from "@/assets/conditions/sexual-health-and-sti-testing.jpg";

export const CONDITION_IMAGES: Record<string, { src: string; alt: string }> = {
  "anxiety-and-depression": {
    src: imgAnxiety,
    alt: "Person relaxing by a window overlooking Rio de Janeiro, representing mental health support in Brazil",
  },
  "travelers-diarrhea": {
    src: imgTravelersDiarrhea,
    alt: "Glass of water, oral rehydration salts and a map of Brazil, representing traveler's diarrhea care",
  },
  "dengue-and-tropical-fevers": {
    src: imgDengue,
    alt: "Thermometer and mosquito repellent near a window with tropical greenery, representing dengue and tropical fevers",
  },
  "respiratory-infections-flu-covid": {
    src: imgRespiratory,
    alt: "Warm tea with lemon, tissues and a thermometer, representing flu and respiratory infection care",
  },
  "skin-rashes-and-insect-bites": {
    src: imgSkin,
    alt: "Healthcare professional examining a mild skin rash on a patient's forearm",
  },
  "urinary-tract-infections": {
    src: imgUti,
    alt: "Glass of water in a bright bathroom, representing hydration and urinary tract health",
  },
  "prescription-refills-chronic-conditions": {
    src: imgRefills,
    alt: "Medication blister packs and passport beside a telemedicine video call, representing prescription refills for expats",
  },
  "childrens-health-pediatrics": {
    src: imgPediatrics,
    alt: "Parent comforting a child during a pediatric telemedicine video call on a tablet",
  },
  "sunburn-heat-illness-and-dehydration": {
    src: imgSunburn,
    alt: "Sunscreen, aloe vera, sunglasses and a water bottle on a Rio de Janeiro beach, representing sun and heat illness care",
  },
  "food-poisoning-and-stomach-pain": {
    src: imgFoodPoisoning,
    alt: "Plain rice, crackers, chamomile tea and water on a table, representing recovery from food poisoning and stomach pain",
  },
  "swimmers-ear-and-ear-infections": {
    src: imgSwimmersEar,
    alt: "Swimming goggles, towel and ear drops by a Rio de Janeiro beach, representing swimmer's ear care",
  },
  "minor-injuries-and-beach-accidents": {
    src: imgMinorInjuries,
    alt: "First aid kit, bandage, gauze and cold pack by a Rio beach, representing minor injury care",
  },
  "sexual-health-and-sti-testing": {
    src: imgSexualHealth,
    alt: "Private consultation setting with a laboratory sample envelope and notebook, representing confidential sexual health care",
  },
};
